<template>
    <div class="items-quotation-page">
        <app-sub-title text="Items para Cotizaciones" />
        <div class="items-quotation-page-buttons">
            <button class="btn btn-primary" v-if="userCan('create-items')" @click="openForm">
                <i class="fa fa-plus"></i> Crear Item
            </button>
            <button class="btn btn-success" v-if="userCan('create-items')" @click="openImportModal">
                <i class="fa fa-upload"></i> Importar Items
            </button>
        </div>
        <app-items-quotation-filters
            :onFilter="onFilter"
            :onClearFilters="onClearFilters"
            :categories="categories"
        />
        <app-items-quotation-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="onDelete"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="item-quotation-form"
            :title="!item ? 'Crear Item' : 'Editar Item'"
            :on-close="() => $bus.$emit('item-quotation-form.clear')"
        >
            <div slot="body">
                <app-items-quotation-form
                    :selected-item="item"
                    :categories="categories"
                    :on-save="onSave"
                    id="item-quotation-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-primary"
                    :disabled="saving"
                    @click="saveItem"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            id="item-quotation-delete-confirm"
            title="Confirmar Eliminación"
            :on-close="onDeleteModalClose"
        >
            <div slot="body">
                <p class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    Esta acción no se puede deshacer.
                </p>
                <p>
                    ¿Está seguro de eliminar el item
                    <strong>"{{ itemToDelete ? itemToDelete.name : '' }}"</strong>?
                </p>
            </div>
            <div slot="buttons">
                <button class="btn btn-danger" @click="confirmDelete" :disabled="deleting">
                    <i class="fa fa-trash"></i> Eliminar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            id="item-quotation-import"
            title="Importar Items desde Excel"
            :on-close="closeImportModal"
        >
            <div slot="body">
                <app-items-quotation-import @import-completed="onImportCompleted" />
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import itemsQuotationRepository from '../../../repositories/items-quotation.repository';
import SubTitle from '../../UI/Layout/SubTitle.vue';
import ItemsQuotationList from './ItemsQuotationList/ItemsQuotationList.vue';
import ItemsQuotationFilters from './ItemsQuotationFilters/ItemsQuotationFilters.vue';
import ItemsQuotationForm from './ItemsQuotationForm/ItemsQuotationForm.vue';
import ItemsQuotationImport from './ItemsQuotationImport/ItemsQuotationImport.vue';
import { mixin } from '../../../mixin';

export default {
    mixins: [mixin],
    components: {
        appSubTitle: SubTitle,
        appItemsQuotationList: ItemsQuotationList,
        appItemsQuotationFilters: ItemsQuotationFilters,
        appItemsQuotationForm: ItemsQuotationForm,
        appItemsQuotationImport: ItemsQuotationImport
    },
    data() {
        return {
            data: {
                data: [],
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
                total: 0,
                per_page: 15
            },
            page: 1,
            filters: {},
            item: null,
            itemToDelete: null,
            deleting: false,
            categories: [],
            sort: {
                sortBy: 'name',
                sortDir: 'asc'
            },
            saving: false
        };
    },
    methods: {
        loadItems() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                page: this.page
            };
            const pr = { ...itemsQuotationRepository };
            pr.getPaged(this.page, filters)
                .then(response => {
                    // Si la respuesta tiene propiedades de paginación (current_page, last_page, etc.)
                    // significa que es un objeto paginado de Laravel
                    if (response && typeof response.current_page !== 'undefined') {
                        this.data = {
                            data: response.data || [],
                            current_page: response.current_page || 1,
                            last_page: response.last_page || 1,
                            from: response.from || 0,
                            to: response.to || 0,
                            total: response.total || 0,
                            per_page: response.per_page || 15
                        };
                    } 
                    // Si response.data existe y es un array, pero no hay paginación
                    else if (Array.isArray(response.data)) {
                        this.data = {
                            data: response.data,
                            current_page: 1,
                            last_page: 1,
                            from: response.data.length > 0 ? 1 : 0,
                            to: response.data.length,
                            total: response.data.length,
                            per_page: response.data.length || 15
                        };
                    } 
                    // Si response.data es un objeto con estructura de paginación
                    else if (response.data && typeof response.data.current_page !== 'undefined') {
                        this.data = response.data;
                    }
                    // Fallback
                    else {
                        this.data = {
                            data: [],
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0,
                            total: 0,
                            per_page: 15
                        };
                    }
                })
                .catch(error => {
                    console.error('Error al cargar items:', error);
                    toastr.error('Ocurrió un error al cargar los items');
                });
        },
        loadCategories() {
            const pr = { ...itemsQuotationRepository };
            pr.getCategories()
                .then(response => {
                    this.categories = response || [];
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al cargar las categorías');
                });
        },
        onChangePage(page) {
            this.page = page;
            this.loadItems();
        },
        onEdit(item) {
            this.item = item;
            this.openForm();
        },
        onDelete(item) {
            this.itemToDelete = item;
            this.openDeleteModal();
        },
        openDeleteModal() {
            this.$bus.$emit('item-quotation-delete-confirm.open');
        },
        onDeleteModalClose() {
            this.itemToDelete = null;
            this.deleting = false;
        },
        closeDeleteModal() {
            this.$bus.$emit('item-quotation-delete-confirm.close');
        },
        confirmDelete() {
            if (!this.itemToDelete) {
                return;
            }

            this.deleting = true;
            const pr = { ...itemsQuotationRepository };
            pr.deleteItem(this.itemToDelete.id)
                .then(response => {
                    if (!response || !response.status) {
                        toastr.error(response?.msg || 'Error al eliminar el item');
                        this.deleting = false;
                        return;
                    }
                    
                    this.closeDeleteModal();
                    this.loadItems();
                    toastr.success(response.msg || 'El item ha sido eliminado');
                    this.deleting = false;
                })
                .catch(error => {
                    console.log('error al eliminar el item', error);
                    toastr.error('Ocurrió un error al eliminar el item');
                    this.deleting = false;
                });
        },
        onFilter(filters) {
            this.page = 1;
            this.filters = filters;
            this.loadItems();
        },
        onClearFilters() {
            this.page = 1;
            this.filters = {};
            this.loadItems();
        },
        saveItem() {
            this.$bus.$emit('item-quotation-form.save');
        },
        onSave() {
            this.closeForm();
            this.loadItems();
        },
        openForm() {
            this.$bus.$emit('item-quotation-form.open');
        },
        closeForm() {
            this.$bus.$emit('item-quotation-form.close');
            this.item = null;
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadItems();
        },
        openImportModal() {
            this.$bus.$emit('item-quotation-import.open');
        },
        closeImportModal() {
            this.$bus.$emit('item-quotation-import.close');
        },
        onImportCompleted() {
            this.loadItems();
            toastr.success('La lista de items se ha actualizado');
        }
    },
    created() {
        this.loadItems();
        this.loadCategories();
    }
};
</script>

